import React, { Component, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { setUser } from "../redux/userSlice";
import jsSHA from "jssha";
import { axiosPost } from "../apis/useAxios";
import secureLocalStorage from "react-secure-storage";
import {
  SetSessionItem,
  ClearSessionItems,
  getCurrentLocation,
  getCurrencyIcon,
} from "../helper/appsession";
import { UserLoginService } from "../apis/apiServices/User";

export function LoginPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);
  //console.log("Login Page user: " + JSON.stringify(user));

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [pwdType, setPwdType] = useState(false);
  const [errors, setErrors] = useState({
    userName: "",
    password: "",
  });

  const calcHash = (value, authToken) => {
    try {
      let shaObj = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
      shaObj.update(value);
      let saltText = shaObj.getHash("HEX");

      let shaObj2 = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
      shaObj2.update(saltText + authToken);

      return shaObj2.getHash("HEX");
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnInputChange = (event) => {
    try {
      const target = event.target;
      const name = target.name;
      const value =
        target.type === "checkbox" || target.type === "radio"
          ? target.checked
          : target.value;

      let err = { ...errors };

      switch (name) {
        case "userName":
          err.userName = "";
          if (value === "" || value.length <= 50) {
            setUserName(value);
          }
          break;
        case "password":
          err.password = "";
          if (value === "" || value.length <= 50) {
            setPassword(value);
          }
          break;
        default:
          break;
      }

      setErrors(err);
    } catch (error) {
      console.log(error);
    }
  };

  const isFormValid = () => {
    let formIsValid = true;
    try {
      let err = { ...errors };
      err.userName = "";
      err.password = "";

      if (!userName) {
        formIsValid = false;
        err.userName = "Please enter username";
      }
      if (!password) {
        formIsValid = false;
        err.password = "Please enter password";
      }

      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return formIsValid;
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isFormValid()) {
        setIsSubmitted(true);

        const authToken = {
          success: true,
          message: "success",
          token: "adfasdfasdfasdfas",
        };

        if (authToken.success) {
          const { lat, lng, ip } = await getCurrentLocation();
          const encryptedPassword = calcHash(password, authToken.token);

          var request = {
            username: userName,
            encryptedPassword: encryptedPassword,
          };

          let response = await UserLoginService(request);
          // let response = { isSuccess: true, data: { userId: 1, username: "admin", } }
          if (response.isSuccess) {
            const currencyIcon = getCurrencyIcon("inr");

            const userPayload = {
              authorized: true,
              currencyIcon,
              userId: response?.data?.userId,
              userName: response?.data?.username,
              firstName: response?.data?.firstName || "",
              lastName: response?.data?.lastName || "",
              userDepartmentId: response?.data?.departmentId,
              userDepartmentName: response?.data?.departmentName,
              levelId: response?.data?.levelId,
            };

            dispatch(setUser(userPayload));

            // ClearSessionItems();
            // SetSessionItem("user", JSON.stringify(userPayload));
            // SetSessionItem("authorized", true);
            // SetSessionItem("currencyicon", currencyIcon);
            secureLocalStorage.setItem("user", userPayload);
            secureLocalStorage.setItem("authorized", true);
            secureLocalStorage.setItem("currencyicon", currencyIcon);

            navigate("/dashboard"); // window.location.href = "/";
          } else {
            let err = { ...errors };
            err.password =
              response.message !== null && response.message !== ""
                ? response.message
                : "Invalid username/password";
            setErrors(err);
          }
        } else {
          let err = { ...errors };
          err.password =
            authToken.message !== null && authToken.message !== ""
              ? authToken.message
              : "Invalid username/password";
          setErrors(err);
        }
      }
    } catch (err) {
      let error = { ...errors };
      error.password = "Invalid username/password";
      setErrors(error);
    } finally {
      setIsSubmitted(false);
    }
  };

  const handleOnPwdShowHide = (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      setPwdType(pwdType === "input" ? "password" : "input");
    } catch (ex) {
      console.log(ex);
    }
  };

  return (
    <div>
      <section className="section hero-img">
        <div className="logo-vse"><img src="./assets/img/logo-vishwa-samudra.png" alt="VISHWAM SAMUDRA | CHALLANEGE IT. CHANGE IT" width="150px" className="p-3" /></div>
        <form className="loginform"
          onSubmit={(e) => {
            handleOnSubmit(e);
          }}
        >
          <div className="logo" style={{ backgroundColor: 'rgba(40, 44, 125, 0.4)' }}>
            <div className="imglogo"><img src="./assets/img/logo-login-vishwam.png" alt="VISHWAM | THE VISHWA SAMUDRA UNIVERSE" className="mt-2" /></div>
          </div>

          <div className="login-form-container" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
            <div className="form-group">
              <label className="text-white mb-1">Username <span className="text-danger">*</span></label>
              <div className="input-group mb-2">
                <input
                  type="text"
                  className="form-control"
                  id="inlineFormInputGroup"
                  placeholder="Username"
                  name="userName"
                  onChange={(e) => handleOnInputChange(e)}
                  value={userName}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="text-white mb-1">Password <span className="text-danger">*</span></label>
              <div className="input-group mb-2">
                <input
                  type={pwdType ? "text" : "password"}
                  className="form-control"
                  id="inlineFormInputGroup2"
                  placeholder="Password"
                  name="password"
                  onChange={(e) => handleOnInputChange(e)}
                  value={password}
                />
                <div className="input-group-prepend">
                  <div className="input-group-text p-0 pl-2 pr-2"><a className="text-dark" href="#">
                    <i className="fas fa-eye-slash" onClick={() => {
                      setPwdType(prevState => !prevState);
                    }}></i>
                  </a></div>
                </div>
              </div>
            </div>
            <div className="d-flex form-group justify-content-between">
              <div className="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  name="remember"
                  className="custom-control-input txt-sm"
                  tabIndex="3"
                  id="remember-me"
                />
                <label
                  className="custom-control-label text-white"
                  htmlFor="remember-me"
                >
                  Remember Me
                </label>
              </div>
              <div
                className="text-right text-white small"
                style={{ cursor: "pointer" }}
              >
                Forgot password?
              </div>
            </div>
          </div>
          <div className="imglogo text-center mb-3"><img src="./assets/img/logo-digilinkz.png" alt="DigilinkZ | Streamlining Storage, Access & Organization" width="200px" /></div>
          <div className="row">
            <div className="col-sm p-5 position-relative" style={{ backgroundColor: 'rgba(40, 44, 125, 0.4)' }}>
              <div className="login-left">
                <div className="imglogo"><img src="./assets/img/logo-login-vishwam.png" alt="VISHWAM | THE VISHWA SAMUDRA UNIVERSE" className="mt-2" /></div>
              </div>
            </div>
            <div className="col-sm p-5" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
              <div className="loginFormContainer">

                <div className="row" style={{ alignItems: 'center' }}>
                  <div className="col-5">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name="remember"
                        className="custom-control-input"
                        tabIndex="3"
                        id="remember-me"
                      />
                      <label
                        className="custom-control-label text-white"
                        htmlFor="remember-me"
                      >
                        Remember Me
                      </label>
                    </div>
                  </div>
                  <div className="col-7 text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      tabIndex="4"
                      title="Login"
                    >
                      <span title="Login">
                        <i
                          className={`fas fa-${isSubmitted ? "spinner fa-spin" : "sign-in-alt"}`}
                        ></i>
                        &nbsp;&nbsp;
                        {isSubmitted ? "Validating" : "Login"}
                      </span>
                    </button>
                  </div>


                </div>
                <div>

                </div>
              </div>
            </div>
          </div>

        </form>
        <div className="text-small login-footer p-2">
          <div className="row m-0">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="text-white text-sm"><span className="copyright">© Copyright 2025 <strong>Vishwa Samudra Engineering</strong></span></div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="text-right text-white text-sm">
                powered by <a href="http://www.plexitech.com/"><img src="../assets/img/logo-plexitech.png" alt="" className="img-filter" width="100" /></a>
              </div>
            </div>
          </div>


        </div>
      </section>
    </div>

  );
}

LoginPage.displayName = "LoginPage"
